import React, { useEffect, useState, createContext } from "react";

export const MainLanguageContext = createContext();

const MainLanguageProvider = ({ children }) => {
  const [mainLanguage, setMainLanguage] = useState("en");

  useEffect(() => {
    document.documentElement.lang = mainLanguage;
    document.documentElement.dir = mainLanguage === "ar" ? "ltr" : "ltr";
  }, [mainLanguage]);

  const handlelanguage = (lang) => {
    setMainLanguage(lang);
  };

  return (
    <MainLanguageContext.Provider value={{ mainLanguage, handlelanguage }}>
      {children}
    </MainLanguageContext.Provider>
  );
};

export default MainLanguageProvider;
